﻿import {
    ValgStateActionTypes,
    ValgState,
    UPDATE_VALG,
    TOGGLE_VILKAR,
    TOGGLE_MODAL,
} from './Types';

export const initialState: ValgState = {
    aVerdensdel: undefined,
    bLand: undefined,
    cLarested: undefined,
    dHelsefag: undefined,
    eEkstraboks: false,
    visVilkar: false,
    visModal: false,
};

export function valgReducer(state: ValgState = initialState, action: ValgStateActionTypes): ValgState {
    const newState = getNewState();
    return newState;

    function getNewState(): ValgState {
        switch (action.type) {
            case UPDATE_VALG: {
                if (action.payload.aVerdensdel) {
                    return {
                        ...initialState,
                        ...action.payload,
                    };
                } else {
                    return {
                        ...state,
                        ...action.payload,
                    };
                }
            }
            case TOGGLE_VILKAR: {
                return {
                    ...state,
                    visVilkar: !state.visVilkar,
                };
            }
            case TOGGLE_MODAL: {
                return {
                    ...state,
                    visModal: !state.visModal,
                };
            }
            default:
                return state;
        }
    }
}
